<template>
<div id="channel-manager" :class="{'pa-2 ma-2': $vuetify.breakpoint.mdAndUp}">
    <im-header :loading="loading">
        <span slot="title">{{ $t('distribution.title') }}</span>
        <span slot="right-content"></span>
    </im-header>

    <v-container fluid :class="{ 'px-1': $vuetify.breakpoint.smAndDown, 'distribution-items': true}">
        <v-row no-gutters>
            <v-col md="4" sm="6" cols="12" class="pa-2">
                <im-card class="" :item="items[0]" @edit="dialog_imemento= true, dialog_item=items[0]"></im-card>
            </v-col>
            <v-col md="4" sm="6" cols="12" v-if="hotel.context == 'imemento'" class="pa-2">
                <im-card :item="items[1]" @edit="dialog_booking= true, dialog_item=items[1]">
                    <template v-slot:footer>
                        <v-divider></v-divider>
                        <div class="detail">
                            {{ $t('distribution.card.footer.booking') }}
                        </div>
                    </template>
                </im-card>
            </v-col>
            <v-col md="4" sm="6" cols="12" class="pa-2">
                <im-card :item="items[2]" @edit="dialog_imemento= true, dialog_item=items[2]"></im-card>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col md="4" sm="6" cols="12" class="pa-2">
                <im-card :item="items[3]" :hotel="hotel" @edit="dialog_imemento= true, dialog_item=items[3]">
                    <template v-slot:footer>
                        <v-divider></v-divider>
                        <div class="detail">
                            {{ $t('distribution.card.footer.booking_engine') }}
                        </div>
                    </template>
                </im-card>
            </v-col>
        </v-row>
    </v-container>

    <modal-imemento :dialog="dialog_imemento" :hotel_id="hotel.id" :hotel="hotel_item" :item="dialog_item" @exit="dialog_imemento=false, dialog_item={}" @update="refresh()"></modal-imemento>

    <modal-booking :dialog="dialog_booking" :hotel="hotel" :item="dialog_item" @exit="dialog_booking=false, dialog_item={}, refresh()"></modal-booking>

</div>
</template>

<script>
import {
    mapActions
} from 'vuex';
import defaults from '../../components/utils/PropDefaults.js';
import IMHeader from '../../components/utils/IMHeader.vue';
import IMFooter from '../../components/utils/IMFooter.vue';
import IMCard from '../../components/items/ChannelManager/DistributionCard.vue';
import ModalImemento from '../../components/items/ChannelManager/ModalImemento.vue';
import ModalBooking from '../../components/items/ChannelManager/ModalBooking.vue';

import CHR from '../../assets/christian_tour.png';
import HLR from '../../assets/helloromania.png';
import Expedia from '../../assets/expedia.png';
import HotelBeds from '../../assets/hotel-beds.jpeg';
import Booking from '../../assets/bookingcom.svg';
import BookingEngine from '../../assets/booking-engine-logo.svg';
export default {

    props: ['hotel'],

    components: {
        "im-footer": IMFooter,
        "im-header": IMHeader,
        "im-card": IMCard,
        "modal-imemento": ModalImemento,
        "modal-booking": ModalBooking,
    },

    data() {
        return {
            dirty: false,
            tab_channels: null,
            info: true,
            loading: false,
            dialog_booking: false,
            dialog_imemento: false,
            dialog_item: {
                name: null,
                slug: null,
                logo: null,
                partner: null,
                partner_id: null,
                integration_id: null,
                connected: false
            },
            pos_slug: null,
            color: {
                booking: '#003580',
                expedia: '#ffcb00',
                'christian-tour': '#f34d10',
                'hotel-beds': '#B52555',
                'hello-romania': '#423e55',
            },
            hotel_item: {},
            items: [
                {
                    name: "Christian Tour",
                    slug: "christian-tour",
                    logo: CHR,
                    patner_id: null,
                    integration_id: null,
                    partner: "imemento",
                    pos_slug: "christiantour",
                    connected: true
                },
                {
                    name: "Booking.com",
                    slug: "booking",
                    logo: Booking,
                    patner_id: null,
                    integration_id: null,
                    partner: "booking",
                    pos_slug: null,
                    connected: false
                },
                {
                    name: "HelloRomania",
                    slug: "hello-romania",
                    logo: HLR,
                    patner_id: null,
                    integration_id: null,
                    partner: "imemento",
                    pos_slug: "helloromania",
                    connected: true
                },
                {
                    name: "Booking engine",
                    slug: "booking-engine",
                    logo: BookingEngine,
                    patner_id: null,
                    integration_id: null,
                    partner: "imemento",
                    pos_slug: "mementobookings",
                    connected: false
                },
             ],

        };
    },

    watch: {
        '$route.params': {
            async handler() {
                await this.hotel
                // react to route changes...
                if(this.$route.params.hotel_slug !== this.hotel.slug) {
                    await this.checkSlug(this.$route.params.hotel_slug)
                    this.refresh();
                } else {
                    this.refresh();
                }
            },
            deep: true,
            immediate: true
        },
    },

    methods: {
        ...mapActions('alert', ['success', 'error']),

        checkSlug(slug) {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/console/v1/hotels/check-slug";
            let params = {
                params: {
                    slug: slug
                }
            };

            return this.$axios.get(endpoint, params)
                .then(response => {
                    if(response.data.exists) {
                        this.$emit('changeHotel', [response.data.hotel_id, false]);
                    } else {
                        this.error("Oops, something went wrong!");
                        this.$router.push({
                            path: '/dashboard',
                        });
                    }
                    return new Promise(function (resolve, reject) {
                        resolve(true);
                    });
                })
                .catch(error => {
                    console.log(error);
                    this.error("Oops, something went wrong!");
                })
                .finally(() => {});
        },

        refresh() {
            this.items.forEach((item, i) => {
                item.integration_id = null;
                item.partner_id = null;
            });
            this.items[1].connected = false;
            this.items[3].connected = false;
            this.getIntegrations();
            this.getInfoHotel();
        },

        getInfoHotel() {
            if(!this.hotel.id) {
                return
            }
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/console/v1/hotels/" + this.hotel.id;

            return this.$axios.get(endpoint)
                .then(response => {
                    this.hotel_item = response.data;
                    if(Array.isArray(this.hotel_item.meta) && this.hotel_item.meta.includes('mementobookings')) {
                        this.items[3].connected = true;
                    }
                })
                .catch(error => {
                    console.log(error);
                    this.error("Oops, something went wrong!");
                })
                .finally(() => {});
        },

        getIntegrations() {
            this.loading = true;

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/cm/integrations";
            let params = {
                params: {
                    system_hotel_id: this.hotel.id,
                }
            };
            this.$axios.get(endpoint, params)
                .then(response => {
                    response.data.data.forEach(function (integration, index) {
                        this.items.forEach(function (item) {
                            if(item.partner == integration.partner_slug && item.slug !== 'booking-engine') {
                                item.connected = true;
                                item.integration_id = integration.id;
                                item.partner_id = integration.partner_hotel_id;
                            }
                        })
                    }.bind(this))
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });

        },
    }
};
</script>
<style lang="stylus">
.distribution-items
    .v-sheet
        border-radius: 5px
        box-shadow: -8px 12px 18px 0 rgba(25,42,70,.13)
        transition: all .3s ease-in-out
        .v-card__text
            color: #727E8C
#channel-manager
    input[type="number"]
        -moz-appearance: textfield
        &::-webkit-outer-spin-button
            -webkit-appearance: none
            margin: 0
        &::-webkit-inner-spin-button
            -webkit-appearance: none
            margin: 0
</style>
